import {
  getUrlCountries,
  getUrlIndicatorMenu,
  getUrlDimensions,
  getUrlIndicator,
  getUrlExternalLayers,
  getUrlBaseLayers,
  getUrlCitiesDepualc,
  getUrlDamDepualc
} from './configQueries'
export const MAP_ID = 'mapa'

// Cache local
const constantData = {
  countries: null,
  citiesDepualc: null,
  damDepualc: null,
  menu: null,
  dimensions: {},
  externalLayers: null,
  baseLayers: null,
  geoJsons: {},
  dataTable: {},
  issues: null
}

export const clearCache = () => {
  constantData.countries = null
  constantData.citiesDepualc = null
  constantData.damDepualc = null
  constantData.menu = null
  constantData.dimensions = {}
  constantData.externalLayers = null
  constantData.baseLayers = null
  constantData.geoJsons = {}
  constantData.dataTable = {}
}

export const getCountries = async () => {
  const { type, features } = await fetch(getUrlCountries()).then((r) =>
    r.json()
  )
  return {
    countries: { type, features }
  }
}
export const getCitiesDepualc = async () => {
  const response = await fetch(getUrlCitiesDepualc()).then((r) => r.json())

  return { citiesDepualc: response }
}
export const getDamDepualc = async () => {
  const response = await fetch(getUrlDamDepualc()).then((r) => r.json())

  return { damDepualc: response }
}
export const getIndicatorMenu = async () => {
  constantData.menu =
    constantData.menu ||
    (await fetch(getUrlIndicatorMenu())
      .then((r) => r.json())
      .then((data) => data?.body?.children || []))
  return constantData.menu
}

export const getDimensions = async ({ id }) => {
  constantData.dimensions[id] =
    constantData.dimensions[id] ||
    (await fetch(getUrlDimensions({ id }))
      .then((response) => response.json())
      .then((data) => {
        const dimensions = data?.body?.dimensions
        const filterDimensions = dimensions.map((dim) => {
          const member = dim.members.map((mem) => {
            return mem.in ? mem : null
          })
          // eslint-disable-next-line no-param-reassign
          dim.members = member.filter((m) => m)
          return dim
        })
        return filterDimensions || []
      }))

  return constantData.dimensions[id]
}

export const getIndicator = async ({ id, members }) => {
  const {
    metadata,
    dimensions,
    data = []
  } = await fetch(getUrlIndicator({ id, members }))
    .then((response) => response.json())
    .then((response) => response?.body)
  return { metadata, dimensions, data }
}

export const getExternalLayers = async () => {
  constantData.externalLayers =
    constantData.externalLayers ||
    (await fetch(getUrlExternalLayers()).then((r) => r.json()))
  return constantData.externalLayers
}

export const getBaseLayers = async () => {
  constantData.baseLayers =
    constantData.baseLayers ||
    (await fetch(getUrlBaseLayers()).then((r) => r.json()))
  return constantData.baseLayers
}

export const getQueryData = async ({ query }) => {
  if (!query) {
    return null
  }
  if (constantData.geoJsons[query]) {
    return constantData.geoJsons[query]
  } else {
    const geoJson = await fetch(query)
      .then((r) => r.json())
      .catch((e) =>
        console.error('%c error in getQueryData: ', 'color: red', e)
      )
    constantData.geoJsons[query] = geoJson
    return constantData.geoJsons[query]
  }
}

const getIssues = async ({
  parallel = 1,
  limit = 10000,
  url = 'issue.json' //https://redmine-pdi.cepal.org/proxy?issues.json'
} = {}) => {
  if (constantData.issues !== null) {
    return constantData.issues
  }
  const issues = []
  let offset = 0
  let hasMore = true
  do {
    const requests = await Promise.all(
      Array(parallel)
        .fill(null)
        .map((v, idx) =>
          fetch(
            `${url}?project_id=redmine-pdi&limit=${limit}&offset=${
              offset + idx * limit
            }`
          ).then((response) => response.json())
        )
    ).then((fetchs) => fetchs.flatMap(({ issues }) => issues))
    issues.push(requests)
    offset += parallel * limit
    hasMore = requests.length % limit === 0
  } while (hasMore)

  constantData.issues = issues.flatMap((issues) => issues)
  return constantData.issues
}

export const getDataTable = async ({ queryRedmine }) => {
  if (constantData.dataTable[queryRedmine]) {
    return constantData.dataTable[queryRedmine]
  } else {
    const issues = await getIssues()

    const dataTable = issues.filter(({ custom_fields }) =>
      custom_fields.some(
        ({ id, value }) =>
          (id === 13 && // 13 - Alcance
            ['Supranacional', 'Nacional', 'Subnacional'].includes(
              queryRedmine
            ) &&
            value === queryRedmine) ||
          (id === 10 && // 10 - ODS
            queryRedmine.slice(0, 3) === 'ods' &&
            value.includes(queryRedmine.slice(4))) ||
          (id === 3 && // 3 - Implementadora
            value.includes(queryRedmine)) ||
          (!isNaN(parseInt(queryRedmine)) &&
            id === parseInt(queryRedmine) &&
            value != '') ||
          (Array.isArray(queryRedmine) && // Pilares
            queryRedmine.includes(id?.toString()) &&
            value != '') ||
          (id === 46 && // 46 - Cooperación
            value.includes(queryRedmine))
      )
    )
    constantData.dataTable[
      typeof queryRedmine !== 'object' ? queryRedmine : queryRedmine.toString()
    ] = dataTable
    return constantData.dataTable[queryRedmine]
  }
}

export const getDataTableByQuery = async ({ subjects }) => {
  const issues = await getIssues()

  const dataTable = subjects
    .map((_subject) => issues.filter(({ subject }) => subject === _subject))
    .flatMap((a) => a)
    .reduce((res, proj) => {
      if (!res.some(({ id }) => id === proj.id)) {
        res.push(proj)
      }
      return res
    }, [])

  return dataTable
}
